import React, { useState, useEffect } from 'react';
import { 
    Spinner, Card, CardBody, Typography, Button, 
    Dialog, DialogHeader, DialogBody, DialogFooter,
    Input, IconButton, Tooltip, Textarea
} from "@material-tailwind/react";
import Axios from 'axios';
import Main from './Main';
import { transformarFechaTramiteSimple } from '../Helpers/fechas';
import Swal from 'sweetalert2';
import { PencilIcon, PlusIcon, TrashIcon } from "@heroicons/react/24/solid";

export default function Delegados({ usuario }) {
    const [datos, setDatos] = useState([]);
    const [buscandoDatos, setBuscandoDatos] = useState(false);
    const [misIglesias, setMisIglesias] = useState([]);
    
    const [openDialog, setOpenDialog] = useState(false);
    const [editando, setEditando] = useState(false);
    const [dataValues, setDataValues] = useState({
        id_iglesia_delegado: null,
        nombre: '',
        apellido: '',
        nro_documento: '',
        id_iglesia: '',
        observaciones: ''
    });

    useEffect(() => {
        obtenerIglesiasObrero();
        obtenerDatos();
    }, []);

    const obtenerDatos = async () => {
        setBuscandoDatos(true);
        try {
            const { data } = await Axios.get(`/api/tablasgenerales/delegados/ministro/${usuario.id_obrero}`);
            setDatos(data);
        } catch (err) {
            console.error("Error al obtener delegados:", err);
        } finally {
            setBuscandoDatos(false);
        }
    };

    const obtenerIglesiasObrero = async () => {
        setBuscandoDatos(true);
        try {
            const { data } = await Axios.get(`/api/tablasgenerales/iglesiasobreroall/${usuario.id_obrero}`);
            setMisIglesias(data.filter(i => i.id_tipo_iglesia == 1));
        } catch (err) {
            console.error("Error al obtener iglesias:", err);
        } finally {
            setBuscandoDatos(false);
        }
    };

    // --- ACCIÓN: ELIMINAR CON CONFIRMACIÓN ---
    const deleteDelegado = async (id_iglesia_delegado) => {
        const result = await Swal.fire({
            title: '¿Estás seguro?',
            text: "Esta acción no se puede deshacer.",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
            try {
                await Axios.delete(`api/tablasgenerales/iglesiadelegado/${id_iglesia_delegado}`);
                Swal.fire('Eliminado', 'El delegado ha sido eliminado con éxito.', 'success');
                obtenerDatos();
            } catch (error) {
                Swal.fire('Error', 'No se pudo eliminar al delegado.', 'error');
            }
        }
    };

    const handleOpenDialog = (delegado = null, idIglesia = null) => {
        if (delegado) {
            setEditando(true);
            setDataValues({
                id_iglesia_delegado: delegado.id_iglesia_delegado,
                nombre: delegado.nombre,
                apellido: delegado.apellido,
                nro_documento: delegado.nro_documento,
                id_iglesia: delegado.id_iglesia,
                observaciones: delegado.observaciones || ''
            });
        } else {
            setEditando(false);
            setDataValues({
                id_iglesia_delegado: null,
                nombre: '',
                apellido: '',
                nro_documento: '',
                id_iglesia: idIglesia,
                observaciones: ''
            });
        }
        setOpenDialog(true);
    };

    const handleDataChanges = (e) => {
        const { name, value } = e.target;
        setDataValues({ ...dataValues, [name]: value });
    };

    const validarDNI = (dni) => {
        const num = Number(dni);
        return num >= 1000000 && num <= 99999999;
    };

    // --- ACCIÓN: GUARDAR/EDITAR CON CONFIRMACIÓN ---
    const submitDelegado = async () => {
        const { nombre, apellido, nro_documento, id_iglesia } = dataValues;

        if (!nombre || !apellido || !nro_documento || !id_iglesia) {
            return Swal.fire("Error", "Por favor, complete todos los campos obligatorios", "error");
        }

        if (!validarDNI(nro_documento)) {
            return Swal.fire("DNI Inválido", "El DNI debe tener entre 7 y 8 dígitos", "warning");
        }

        const result = await Swal.fire({
            title: editando ? '¿Confirmar edición?' : '¿Confirmar creación?',
            text: `¿Deseas ${editando ? 'guardar los cambios' : 'crear este nuevo delegado'}?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Sí, confirmar',
            cancelButtonText: 'Revisar'
        });

        if (result.isConfirmed) {
            try {
                if (editando) {
                    await Axios.put(`/api/tablasgenerales/iglesiadelegado/${dataValues.id_iglesia_delegado}`, dataValues);
                } else {
                    await Axios.post(`/api/tablasgenerales/iglesiadelegado`, dataValues);
                }

                Swal.fire("Éxito", `Operación realizada correctamente`, "success");
                setOpenDialog(false);
                obtenerDatos();
            } catch (error) {
                const msg = error.response?.data?.message || "Error al procesar la solicitud";
                Swal.fire("Error", msg, "error");
            }
        }
    };

    if (buscandoDatos) {
        return (
            <Main center alinear>
                <div className='flex flex-col justify-center items-center h-[calc(100vh-10rem)]'>
                    <Spinner className="h-12 w-12" />
                    <span className="mt-4 font-semibold text-gray-600">Cargando delegados...</span>
                </div>
            </Main>
        );
    }

    return (
        <Main>
            <Typography
                variant="small"
                color="gray"
                className="flex items-center justify-center gap-2 font-semibold text-black text-[20px] mb-4 mt-4"
            >
                {`Delegados autorizados por iglesia autónoma`}
            </Typography>
            <h1 style={{color:'red',textAlign:'center'}}>En desarrollo solo visible para usuario Ezequiel St.</h1>
            <div className="container mx-auto pb-10">
                {misIglesias.map(iglesia_ministro => {
                    const infoIglesia = { ...iglesia_ministro };
                    const delegadosDeEstaIglesia = datos.filter(d => d.id_iglesia === iglesia_ministro.id_iglesia);

                    return (
                        <div key={iglesia_ministro.id_iglesia} className="mt-8 mb-12">
                            <div className="flex justify-between items-end ml-auto mr-auto w-[90%] lg:w-[65%] mb-2">
                                <div>
                                    <Typography variant="h5" color="blue-gray" className="font-bold">
                                        {infoIglesia?.iglesia}
                                    </Typography>
                                    <Typography variant="small" className="font-normal text-gray-500">
                                        {infoIglesia?.localidad}
                                    </Typography>
                                </div>
                                <Button 
                                    size="sm" 
                                    className="flex items-center gap-2" 
                                    color="blue"
                                    onClick={() => handleOpenDialog(null, iglesia_ministro.id_iglesia)}
                                >
                                    <PlusIcon className="h-4 w-4" /> Agregar
                                </Button>
                            </div>

                            <Card className="w-[90%] lg:w-[65%] mx-auto shadow-sm border border-gray-200">
                                <CardBody className="p-0 overflow-x-auto">
                                    <table className="w-full min-w-max table-auto text-left">
                                        <thead>
                                            <tr className="bg-gray-50">
                                                {['Nombre', 'DNI', 'Alta', 'Acciones'].map((head) => (
                                                    <th key={head} className="p-4 border-b border-gray-100">
                                                        <Typography variant="small" color="blue-gray" className="font-bold opacity-80">{head}</Typography>
                                                    </th>
                                                ))}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {delegadosDeEstaIglesia.map((item) => (
                                                <React.Fragment key={item.id_iglesia_delegado}>
                                                    <tr className="hover:bg-blue-gray-50/50">
                                                        <td className="p-4 border-b border-gray-50">
                                                            <Typography variant="small" className="font-bold text-blue-gray-800">
                                                                {`${item.nombre} ${item.apellido}`.toUpperCase()}
                                                            </Typography>
                                                        </td>
                                                        <td className="p-4 border-b border-gray-50">
                                                            <Typography variant="small">{item.nro_documento}</Typography>
                                                        </td>
                                                        <td className="p-4 border-b border-gray-50">
                                                            <Typography variant="small">{transformarFechaTramiteSimple(item.fecha_alta)}</Typography>
                                                        </td>
                                                        <td className="p-4 border-b border-gray-50 flex gap-2">
                                                            <Tooltip content="Editar Datos">
                                                                <IconButton variant="text" onClick={() => handleOpenDialog(item)}>
                                                                    <PencilIcon className="h-4 w-4 text-blue-500" />
                                                                </IconButton>
                                                            </Tooltip>
                                                            <Tooltip content="Eliminar al delegado">
                                                                <IconButton variant="text" onClick={() => deleteDelegado(item.id_iglesia_delegado)}>
                                                                    <TrashIcon className="h-4 w-4 text-red-500" />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </td>
                                                    </tr>
                                                    {item.observaciones && (
                                                        <tr>
                                                            <td colSpan={4} className="p-4 pt-0 border-b border-gray-50 bg-gray-50/30">
                                                                <Typography variant="small" className="italic text-gray-600 text-xs">
                                                                    <strong>Obs:</strong> {item.observaciones}
                                                                </Typography>
                                                            </td>
                                                        </tr>
                                                    )}
                                                </React.Fragment>
                                            ))}
                                        </tbody>
                                    </table>
                                </CardBody>
                            </Card>
                        </div>
                    );
                })}
            </div>

            <Dialog open={openDialog} handler={() => setOpenDialog(false)} size="sm">
                <DialogHeader>{editando ? 'Editar' : 'Nuevo'} Delegado</DialogHeader>
                <DialogBody divider className="flex flex-col gap-4">
                    <div className="flex gap-4">
                        <Input label="Nombre" name="nombre" value={dataValues.nombre} onChange={handleDataChanges} />
                        <Input label="Apellido" name="apellido" value={dataValues.apellido} onChange={handleDataChanges} />
                    </div>
                    <Input 
                        label="DNI (7 u 8 dígitos)" 
                        name="nro_documento" 
                        type="number"
                        value={dataValues.nro_documento} 
                        onChange={handleDataChanges} 
                    />
                    <Textarea 
                        label="Observaciones" 
                        name="observaciones" 
                        value={dataValues.observaciones} 
                        onChange={handleDataChanges} 
                    />
                </DialogBody>
                <DialogFooter className="space-x-2">
                    <Button variant="text" color="red" onClick={() => setOpenDialog(false)}>Cancelar</Button>
                    <Button variant="gradient" color="green" onClick={submitDelegado}>Guardar</Button>
                </DialogFooter>
            </Dialog>
        </Main>
    );
}